/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FieldTypeMeta } from './FieldTypeMeta';
import {
    FieldTypeMetaFromJSON,
    FieldTypeMetaFromJSONTyped,
    FieldTypeMetaToJSON,
    FieldTypeMetaToJSONTyped,
} from './FieldTypeMeta';
import type { StatusMeta } from './StatusMeta';
import {
    StatusMetaFromJSON,
    StatusMetaFromJSONTyped,
    StatusMetaToJSON,
    StatusMetaToJSONTyped,
} from './StatusMeta';
import type { LabelledChoice } from './LabelledChoice';
import {
    LabelledChoiceFromJSON,
    LabelledChoiceFromJSONTyped,
    LabelledChoiceToJSON,
    LabelledChoiceToJSONTyped,
} from './LabelledChoice';
import type { FieldNamesMeta } from './FieldNamesMeta';
import {
    FieldNamesMetaFromJSON,
    FieldNamesMetaFromJSONTyped,
    FieldNamesMetaToJSON,
    FieldNamesMetaToJSONTyped,
} from './FieldNamesMeta';

/**
 * Everything the editor needs to populate its controls, scoped to one definition.
 * 
 * Served rather than hardcoded client-side: the status order, the operators legal per field
 * type and the actions a company may configure all live in Python and would otherwise be
 * duplicated in TypeScript and drift.
 * @export
 * @interface EditorMetadata
 */
export interface EditorMetadata {
    /**
     * 
     * @type {Array<StatusMeta>}
     * @memberof EditorMetadata
     */
    statuses: Array<StatusMeta>;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditorMetadata
     */
    transitionTypes: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditorMetadata
     */
    logicalOperators: Array<string>;
    /**
     * 
     * @type {Array<LabelledChoice>}
     * @memberof EditorMetadata
     */
    linkingStrategies: Array<LabelledChoice>;
    /**
     * 
     * @type {Array<FieldTypeMeta>}
     * @memberof EditorMetadata
     */
    fieldTypes: Array<FieldTypeMeta>;
    /**
     * 
     * @type {FieldNamesMeta}
     * @memberof EditorMetadata
     */
    fieldNames: FieldNamesMeta;
    /**
     * 
     * @type {Array<LabelledChoice>}
     * @memberof EditorMetadata
     */
    geoAreas: Array<LabelledChoice>;
    /**
     * 
     * @type {number}
     * @memberof EditorMetadata
     */
    geoAreasCount: number;
    /**
     * 
     * @type {Array<LabelledChoice>}
     * @memberof EditorMetadata
     */
    dataProviders: Array<LabelledChoice>;
    /**
     * 
     * @type {Array<LabelledChoice>}
     * @memberof EditorMetadata
     */
    availableActions: Array<LabelledChoice>;
}

/**
 * Check if a given object implements the EditorMetadata interface.
 */
export function instanceOfEditorMetadata(value: object): value is EditorMetadata {
    if (!('statuses' in value) || value['statuses'] === undefined) return false;
    if ((!('transitionTypes' in (value as Record<string, any>)) && !('transition_types' in (value as Record<string, any>))) || ((value as Record<string, any>)['transitionTypes'] === undefined && (value as Record<string, any>)['transition_types'] === undefined)) return false;
    if ((!('logicalOperators' in (value as Record<string, any>)) && !('logical_operators' in (value as Record<string, any>))) || ((value as Record<string, any>)['logicalOperators'] === undefined && (value as Record<string, any>)['logical_operators'] === undefined)) return false;
    if ((!('linkingStrategies' in (value as Record<string, any>)) && !('linking_strategies' in (value as Record<string, any>))) || ((value as Record<string, any>)['linkingStrategies'] === undefined && (value as Record<string, any>)['linking_strategies'] === undefined)) return false;
    if ((!('fieldTypes' in (value as Record<string, any>)) && !('field_types' in (value as Record<string, any>))) || ((value as Record<string, any>)['fieldTypes'] === undefined && (value as Record<string, any>)['field_types'] === undefined)) return false;
    if ((!('fieldNames' in (value as Record<string, any>)) && !('field_names' in (value as Record<string, any>))) || ((value as Record<string, any>)['fieldNames'] === undefined && (value as Record<string, any>)['field_names'] === undefined)) return false;
    if ((!('geoAreas' in (value as Record<string, any>)) && !('geo_areas' in (value as Record<string, any>))) || ((value as Record<string, any>)['geoAreas'] === undefined && (value as Record<string, any>)['geo_areas'] === undefined)) return false;
    if ((!('geoAreasCount' in (value as Record<string, any>)) && !('geo_areas_count' in (value as Record<string, any>))) || ((value as Record<string, any>)['geoAreasCount'] === undefined && (value as Record<string, any>)['geo_areas_count'] === undefined)) return false;
    if ((!('dataProviders' in (value as Record<string, any>)) && !('data_providers' in (value as Record<string, any>))) || ((value as Record<string, any>)['dataProviders'] === undefined && (value as Record<string, any>)['data_providers'] === undefined)) return false;
    if ((!('availableActions' in (value as Record<string, any>)) && !('available_actions' in (value as Record<string, any>))) || ((value as Record<string, any>)['availableActions'] === undefined && (value as Record<string, any>)['available_actions'] === undefined)) return false;
    return true;
}

export function EditorMetadataFromJSON(json: any): EditorMetadata {
    return EditorMetadataFromJSONTyped(json, false);
}

export function EditorMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): EditorMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'statuses': ((json['statuses'] as Array<any>).map(StatusMetaFromJSON)),
        'transitionTypes': json['transition_types'],
        'logicalOperators': json['logical_operators'],
        'linkingStrategies': ((json['linking_strategies'] as Array<any>).map(LabelledChoiceFromJSON)),
        'fieldTypes': ((json['field_types'] as Array<any>).map(FieldTypeMetaFromJSON)),
        'fieldNames': FieldNamesMetaFromJSON(json['field_names']),
        'geoAreas': ((json['geo_areas'] as Array<any>).map(LabelledChoiceFromJSON)),
        'geoAreasCount': json['geo_areas_count'],
        'dataProviders': ((json['data_providers'] as Array<any>).map(LabelledChoiceFromJSON)),
        'availableActions': ((json['available_actions'] as Array<any>).map(LabelledChoiceFromJSON)),
    };
}

export function EditorMetadataToJSON(json: any): EditorMetadata {
    return EditorMetadataToJSONTyped(json, false);
}

export function EditorMetadataToJSONTyped(value?: EditorMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'statuses': ((value['statuses'] as Array<any>).map(StatusMetaToJSON)),
        'transition_types': value['transitionTypes'],
        'logical_operators': value['logicalOperators'],
        'linking_strategies': ((value['linkingStrategies'] as Array<any>).map(LabelledChoiceToJSON)),
        'field_types': ((value['fieldTypes'] as Array<any>).map(FieldTypeMetaToJSON)),
        'field_names': FieldNamesMetaToJSON(value['fieldNames']),
        'geo_areas': ((value['geoAreas'] as Array<any>).map(LabelledChoiceToJSON)),
        'geo_areas_count': value['geoAreasCount'],
        'data_providers': ((value['dataProviders'] as Array<any>).map(LabelledChoiceToJSON)),
        'available_actions': ((value['availableActions'] as Array<any>).map(LabelledChoiceToJSON)),
    };
}

